/* eslint-disable @typescript-eslint/no-unused-vars */
import {configureStore} from '@reduxjs/toolkit';
import rootReducer from './redux/reducers';
import {NODE_ENV} from './config/config';

// Configure the store with Redux Toolkit
const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // This replaces our custom nonSerializableMiddleware
        }),
    devTools: NODE_ENV !== 'production', // Automatically enables Redux DevTools in development
});

// Add this for better React 18 compatibility
const originalDispatch = store.dispatch;
store.dispatch = function customDispatch(action) {
    try {
        return originalDispatch(action);
    } catch (err) {
        console.error('Error in dispatch:', err);
        throw err;
    }
};

export default store;